import { Component } from "react";

/**
 * Catches render/runtime errors anywhere below it and shows a branded fallback
 * instead of a blank white screen. Kept intentionally dependency-light (plain
 * elements, no shadcn/UI imports) so the fallback itself can't fail.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Console for local debugging; GlitchTip (window.Sentry) if it's wired.
    console.error("App crashed:", error, info);
    if (typeof window !== "undefined" && window.Sentry?.captureException) {
      window.Sentry.captureException(error);
    }
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="fixed inset-0 z-[70] grid max-h-[100dvh] place-items-center overflow-y-auto bg-brand-canvas px-4 pb-[env(safe-area-inset-bottom)] pt-[env(safe-area-inset-top)] text-brand-ink">
        <div className="w-full max-w-[420px] rounded-[20px] border border-black/5 bg-white/80 p-7 text-center shadow-xl">
          <img src="/logo-mark.png" alt="Greentek Alliance" className="mx-auto mb-4 h-12 w-12" />
          <h1 className="brand-title text-xl font-semibold">Something went wrong</h1>
          <p className="mt-2 text-sm text-brand-muted">
            The page hit an unexpected error. Reloading usually fixes it — if it keeps
            happening, please let us know.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="mt-5 h-11 w-full rounded-[12px] bg-brand-forest font-semibold text-white"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
